import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useEditExpensePlanSchema = () => {
  const { t } = useTranslation();

  const schema = z.object({
    planName: z
      .string()
      .trim()
      .refine((value) => value !== "", {
        message: t("common.form.field.errors.required"),
      }),
    planAmount: z
      .number({ required_error: t("common.form.field.errors.required") })
      .or(
        z
          .string({ required_error: t("common.form.field.errors.required") })
          .trim()
          .refine((value) => value !== "", {
            message: t("common.form.field.errors.required"),
          }),
      ),
    bankAccountId: z.number().optional(),
  });

  return schema;
};

export type TEditExpensePlanSchema = z.infer<
  ReturnType<typeof useEditExpensePlanSchema>
>;
